function Comics(minigameData){
    return {
        imageset: Array(minigameData.count).fill(0).map((_, i) => `comics${minigameData.number}/${i}.png`)
    };
}

export default Comics;